import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, Autocomplete, FormControl, InputLabel, Checkbox, Chip } from "@mui/material";
import Header from "../../components/Header";
import apiService from "../../service/apiService";
import { FaRegEdit, FaEye, FaTrash } from "react-icons/fa";
import { Pagination } from "react-bootstrap";
import * as XLSX from 'xlsx';
import { Download } from "@mui/icons-material";
import { format, parseISO } from "date-fns";
import { FormHelperText } from "@mui/material";
import { useCallback } from "react";
import { debounce } from "lodash";


const Capacitybuild = () => {
    const [open, setOpen] = useState(false);
    const [CapacityBuildingSubTypeName, setCapacityBuildingSubTypeName] = useState("");
    const [SubtypeList, setSubtypeList] = useState([]);
    const [subtypes, setSubtypes] = useState([]);
    const [pageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [alldata, setAllData] = useState([]);
    const [District, setDistrict] = useState("");
    const [block, setBlock] = useState("");
    const [dates, setDate] = useState("");
    const [Venue, setVenue] = useState("");
    const [designation, setDesignation] = useState("");
    const [totalItems, setTotalitems] = useState(0);
    const [totalpage, setTotalpage] = useState(0);
    const [ResourcePerson, setResourcePerson] = useState('');
    const [CapacityBuildingId, setCapacityBuildingId] = useState(null);
    const [Season, setSeason] = useState("");
    const [CapacityBuildingTypeName, setCapacityBuildingTypeName] = useState('');
    const [Topic, setTopic] = useState('');
    const [year, setYear] = useState(new Date().getFullYear());
    const [Mip, setMip] = useState('');
    const [farmers, setFarmers] = useState([]);
    const navigate = useNavigate();
    const [mipOptions, setMipOptions] = useState([]);
    const [producerGroupOptions, setProducerGroupOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [blockOptions, setBlockOptions] = useState([]);
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    const [dist, setDist] = useState(loginData?.districtId ? loginData.districtId : 0);
    const [blk, setBlk] = useState(loginData?.blockId ? loginData.blockId : 0);
    const [errors, setErrors] = useState({});
    const [seasons, setSeasons] = useState([]);
    const [capacityBuildingTypes, setCapacityBuildingTypes] = useState([]);
    const [formData, setFormData] = useState({
        mipIds: [],
        yearId: "",
        seasonId: "",
        capacityBuildingTypeId: "",
        date: "",
        venue: "",
        topic: "",
        producerGroupIds: [],
        resourcePerson: "",
        designation: "",
        blockId: "",
        districtId: "",
    });
    const [years, setYears] = useState([]);
    useEffect(() => {
        if (!CapacityBuildingTypeName) {
            setSubtypeList([]);
            setCapacityBuildingSubTypeName("");
            return;
        }

        // Convert TypeName → TypeId (static mapping)
        const typeMapping = {
            "Exposure Visit": 3,
            "Cluster Training": 1,
            "Awareness Meeting": 2
        };

        const typeId = typeMapping[CapacityBuildingTypeName];

        if (!typeId) return;

        apiService
            .get(`/capacity-building/capacity-building-types/${typeId}/active-subtypes`)
            .then((res) => {
                setSubtypeList(res.data.body || []);
            })
            .catch((err) => console.error("Error fetching subtypes:", err));
    }, [CapacityBuildingTypeName]);

    const fetchCapacityBuildingTypes = async () => {
        try {
            const response = await apiService.get("/capacity-building-types/get-all");
            setCapacityBuildingTypes(response.data);
        } catch (error) {
            console.error("Error fetching capacity building types:", error);
        }
    };

    const fetchSubtypes = async (capacityBuildingTypeId) => {
        try {
            const res = await apiService.get(
                `/capacity-building/capacity-building-types/${capacityBuildingTypeId}/active-subtypes`
            );

            const subtypeList = res.data.body || [];

            setSubtypes(Array.isArray(subtypeList) ? subtypeList : [subtypeList]);
        } catch (error) {
            console.error("Error fetching subtypes:", error);
            setSubtypes([]);
        }
    };

    const fetchYears = async () => {
        try {
            const response = await apiService.get("/years/get-all");
            setYears(response.data);
            const currentYear = new Date().getFullYear();
            const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

            setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
        } catch (error) {
            console.error("Error fetching years:", error);
        }
    };
    const fetchSeasons = async () => {
        try {
            const response = await apiService.get("/seasons/get-all");
            setSeasons(response.data);
        } catch (error) {
            console.error("Error fetching seasons:", error);
        }
    };
    const fetchProducerGroups = async () => {
        try {
            const response = await apiService.get("/producer-groups/get-all");
            setProducerGroupOptions(response.data); // Set the fetched data
        } catch (error) {
            console.error("Error fetching producer groups:", error);
        }
    };

    useEffect(() => {
        if (formData.districtId) {
            apiService.get(`/master/get-block-by-district/${formData.districtId}`)
                .then((response) => {
                    if (response.data.status) {
                        setBlockOptions(response.data.body.blocks || []);

                        // Retain previously selected block if it exists in new block list
                        const blockExists = response.data.body.blocks.some(
                            (block) => block.blockId === formData.blockId
                        );

                        if (!blockExists) {
                            setFormData((prev) => ({ ...prev, blockId: "" }));
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error fetching blocks:", error);
                });
        } else {
            setBlockOptions([]); // Reset blocks if district is cleared
            setFormData((prev) => ({ ...prev, blockId: "" }));
        }
    }, [formData.districtId]);

    useEffect(() => {
        if (formData.blockId) {
            apiService.get(`/master/get-mip-by-block/${formData.blockId}`)
                .then((response) => {
                    if (response.data.status) {
                        setMipOptions(response.data.body || []);

                        // Retain previously selected MIPs if they exist in new list
                        const validMipIds = response.data.body.map(mip => mip.mipid);
                        setFormData((prev) => ({
                            ...prev,
                            mipIds: prev.mipIds.filter(id => validMipIds.includes(id))
                        }));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching MIPs:", error);
                });
        } else {
            setMipOptions([]);
            setFormData((prev) => ({ ...prev, mipIds: [] }));
        }
    }, [formData.blockId]);


    const fetchDistricts = async () => {
        try {
            const response = await apiService.get("/districts/get-all");
            setDistrictOptions(response.data); // Set the fetched data
        } catch (error) {
            console.error("Error fetching districts:", error);
        }
    };

    const fetchAllDist = async () => {
        try {
            const response = await apiService.get('/districts/get-all');
            const currentDist = loginData?.districtId ? loginData.districtId : 0;

            if (currentDist) {
                const defDist = response.data.find((dis) => dis.districtId === currentDist);
                setDistrict(defDist ? defDist.districtName : "");
            }

        } catch (error) {
            setDistrict("");
            console.error('Error fetching seeds:', error);
        }
    };

    useEffect(() => {
        fetchDistricts();
        fetchProducerGroups();
        fetchCapacityBuildingTypes();
        fetchSeasons();
        fetchYears();
        fetchAllDist();
    }, []);

    const fetchAllBlocks = async () => {
        try {
            const response = await apiService.get(`/master/get-block-by-district/${dist}`);
            const currentBlock = loginData?.blockId ? loginData.blockId : 0;

            if (currentBlock) {
                const defBlock = response.data.body.blocks.find((blk) => blk.blockId === currentBlock);
                setBlock(defBlock ? defBlock.blockName : "");
            }
        } catch (error) {
            setBlock("");
            console.error("Error fetching blocks:", error);
        }
    }

    useEffect(() => {
        if (dist > 0) {
            fetchAllBlocks();
        }
    }, [dist]);

    const validateForm = () => {
        let newErrors = {};

        if (!formData.yearId) newErrors.yearId = "Year is required";
        if (!formData.seasonId) newErrors.seasonId = "Season is required";
        if (!formData.capacityBuildingTypeId) newErrors.capacityBuildingTypeId = "Capacity Building Type is required";
        if (!formData.mipIds || formData.mipIds.length === 0) newErrors.mipIds = "At least one MIP is required";
        if (!formData.date) newErrors.date = "Date is required";
        if (!formData.venue) newErrors.venue = "Venue is required";
        if (!formData.topic) newErrors.topic = "Topic is required";
        if (!formData.producerGroupIds || formData.producerGroupIds.length === 0) newErrors.producerGroupIds = "At least one Producer Group is required";
        if (!formData.resourcePerson) newErrors.resourcePerson = "Resource Person is required";
        if (!formData.designation) newErrors.designation = "Designation is required";
        if (!formData.blockId) newErrors.blockId = "Block is required";
        if (!formData.districtId) newErrors.districtId = "District is required";
        if (!formData.farmerIds || formData.farmerIds.length === 0) newErrors.farmerIds = "At least one Farmer is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const fetchData = async () => {
        try {
            const payload = {
                seasonId: 0,
                blockId: 0,
                districtId: 0,
                mipId: 0,
                yearValue: year,
                capacityBuildingTypeName: CapacityBuildingTypeName || "",
                subtypeName: CapacityBuildingSubTypeName || "",
                topic: Topic || "",
                venue: Venue || "",
                resourcePersonName: ResourcePerson || "",
                designation: designation || "",
                mipName: Mip || "",
                pgName: "",
                districtName: District || "",
                blockName: block || "",
                seasonName: Season || "",
                date: dates || "",
                farmers: null,
                pageNumber: page || 1,
                pageSize: pageSize || 10,
            };

            const response = await apiService.post(
                "/capacity-building/get-capacity-building",
                payload
            );

            const { data } = response.data.body;
            setAllData(data);
            setTotalitems(response.data.body.recordsCount);
            setTotalpage(response.data.body.pageCount);
        } catch (error) {
            console.error("Error fetching data:", error);
            setAllData([]);
            setTotalitems(0);
            setTotalpage(0);
        }
    };

    const debouncedFetchData = useCallback(debounce(fetchData, 500), [
        page,
        pageSize,
        District,
        block,
        Mip,
        dates,
        Venue,
        ResourcePerson,
        designation,
        Season,
        CapacityBuildingTypeName,
        Topic,
        year,
        CapacityBuildingSubTypeName,
    ]);

    useEffect(() => {
        debouncedFetchData();
        return () => debouncedFetchData.cancel();
    }, [debouncedFetchData]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === 'mipIds' || name === 'producerGroupIds' || name === 'farmerIds' || name === 'seedIds' || name === 'seedVarietyIds'
                ? value
                : value,
        }));
        if (name === "capacityBuildingTypeId") {
            fetchSubtypes(value);   // <-- fetch subtype list on type change
            setFormData((prev) => ({ ...prev, capacityBuildingSubtypeId: "" }));
        }
        if (name === 'producerGroupIds') {
            fetchFarmers(value);
        }
    };


    const fetchFarmers = (selectedProducerGroupIds) => {
        if (selectedProducerGroupIds.length === 0) {
            setFarmers([]); // Clear farmer list if no producer groups are selected
            return;
        }

        apiService.post('/farmers/detail', {
            ProducerGroupId: selectedProducerGroupIds,
        })
            .then((response) => {
                setFarmers(response.data); // Store the farmer details
            })
            .catch((error) => {
                console.error('Error fetching farmer data:', error);
            });
    };



    useEffect(() => {
        const fetchFarmers = async () => {
            try {
                const response = await apiService.post("/farmers/detail", {
                    ProducerGroupId: formData.producerGroupIds,
                });

                const fetchedFarmers = response.data;

                setFarmers((prevFarmers) => {
                    const existingFarmers = prevFarmers.filter((farmer) =>
                        formData.farmerIds.includes(farmer.FarmerId)
                    );

                    // If selected farmers are missing, add them back
                    const missingFarmers = formData.farmerIds
                        .filter((farmerId) => !fetchedFarmers.some((f) => f.FarmerId === farmerId))
                        .map((farmerId) => ({
                            FarmerId: farmerId,
                            FarmerName: `Farmer ${farmerId}`, // Placeholder if name is missing
                        }));

                    // Merge fetched farmers with existing ones, avoiding duplicates
                    return [...existingFarmers, ...fetchedFarmers, ...missingFarmers].reduce((acc, farmer) => {
                        if (!acc.some((f) => f.FarmerId === farmer.FarmerId)) {
                            acc.push(farmer);
                        }
                        return acc;
                    }, []);
                });
            } catch (error) {
                console.error("Error fetching Farmer data:", error);
            }
        };

        if (formData.producerGroupIds.length > 0) {
            fetchFarmers();
        } else {
            setFarmers([]);
        }
    }, [formData.producerGroupIds, formData.farmerIds]);


    const handleView = (data) => {
        const { capacityBuildingId } = data;
        navigate('/childcapacitybuild', { state: { capacityBuildingId } });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenEdit = async (data) => {
        const { capacityBuildingId } = data;

        try {
            // Store the ID for update API
            setCapacityBuildingId(capacityBuildingId);

            // Fetch capacity building details
            const response = await apiService.get(`/capacity-building/${capacityBuildingId}`);

            if (response.status === 200) {
                const fetchedData = response.data;

                // Fetch subtype list based on type
                await fetchSubtypes(fetchedData.capacityBuildingTypeId);

                // Set form data
                setFormData({
                    yearId: fetchedData.yearId || "",
                    seasonId: fetchedData.seasonId || "",
                    capacityBuildingTypeId: fetchedData.capacityBuildingTypeId || "",
                    capacityBuildingSubtypeId: fetchedData.capacityBuildingSubtypeId || "",
                    mipIds: fetchedData.mipIds || [],
                    date: fetchedData.date || "",
                    farmerIds: fetchedData.farmerIds || [],
                    venue: fetchedData.venue || "",
                    topic: fetchedData.topic || "",
                    producerGroupIds: fetchedData.producerGroupIds || [],
                    resourcePerson: fetchedData.resourcePerson || "",
                    designation: fetchedData.designation || "",
                    blockId: fetchedData.blockId || "",
                    districtId: fetchedData.districtId || "",
                    subtypeName: fetchedData.subtypeName || "",
                });

                setOpen(true); // open the dialog
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        }
    };
    useEffect(() => {
        if (formData.capacityBuildingTypeId) {
            fetchSubtypes(formData.capacityBuildingTypeId);
        }
    }, [formData.capacityBuildingTypeId]);


    const handleSaveEdit = async () => {
        if (validateForm()) {
            const confirmUpdate = window.confirm("Are you sure you want to update the details?");

            if (!confirmUpdate) {
                return; // If user cancels, exit the function
            }
            try {
                const formattedDate = formData.date
                    ? formData.date.split('-').reverse().join('-') // Converts "2025-01-08" to "08-01-2025"
                    : null;



                const payload = {
                    farmerIds: formData.farmerIds,
                    date: formattedDate,
                    venue: formData.venue,
                    resourcePerson: formData.resourcePerson,
                    capacityBuildingTypeId: formData.capacityBuildingTypeId,
                    capacityBuildingSubtypeId: formData.capacityBuildingSubtypeId,  // <-- NEW
                    yearId: formData.yearId,
                    blockId: formData.blockId,
                    districtId: formData.districtId,
                    seasonId: formData.seasonId,
                    producerGroupIds: formData.producerGroupIds || [],
                    topic: formData.topic,
                    designation: formData.designation,
                    mipIds: formData.mipIds || [],
                };

                // Make the API call
                const response = await apiService.put(
                    `/capacity-building/update/${CapacityBuildingId}`, // Correct API endpoint with capacityBuildingId
                    payload
                );

                // Handle the response
                if (response.status === 200 || response.status === 201) {
                    const data = response.data; // Assuming `apiService` is using Axios
                    console.log('Success:', data);
                    alert('Capacity Building details updated successfully.');
                    handleClose();
                    fetchData();
                } else {
                    console.error('Error:', response);
                    alert(`Failed to update details. Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error:', error);
                alert('An error occurred while saving the changes. Please try again.');
            }
        }
    };

    const handleDelete = async (data) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this record?");
        if (!confirmDelete) return;

        const { capacityBuildingId } = data;

        try {
            const response = await apiService.delete(`/capacity-building/delete/${capacityBuildingId}`);
            if (response.status === 200) {
                alert('Deleted successfully');
                fetchData();
            } else {
                alert('Error deleting record');
            }
        } catch (error) {
            console.error('Error deleting record:', error);
            alert('Error deleting record');
        }
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const startItem = (page - 1) * 10 + 1;
    const endItem = Math.min(page * 10, totalItems);

    const renderPaginationItems = () => {
        const paginationItems = [];
        const maxPagesToShow = 7;
        const startPages = 3;
        const endPages = 2;

        if (totalpage <= maxPagesToShow) {
            for (let pages = 1; pages <= totalpage; pages++) {
                paginationItems.push(
                    <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
                        {pages}
                    </Pagination.Item>
                );
            }
        } else {
            // Show first 3 pages
            for (let pages = 1; pages <= startPages; pages++) {
                paginationItems.push(
                    <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
                        {pages}
                    </Pagination.Item>
                );
            }

            // Show ellipsis if necessary
            if (page > startPages + 1) {
                paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
            }

            // Show the middle pages around the current page
            const middlePages = [];
            const startMiddlePage = Math.max(page - 1, startPages + 1);
            const endMiddlePage = Math.min(page + 1, totalpage - endPages);

            for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
                middlePages.push(
                    <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
                        {pages}
                    </Pagination.Item>
                );
            }

            paginationItems.push(...middlePages);

            // Show ellipsis if necessary
            if (page < totalpage - endPages - 1) {
                paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
            }

            // Show last 2 pages
            for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
                paginationItems.push(
                    <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
                        {pages}
                    </Pagination.Item>
                );
            }
        }

        return paginationItems;
    };

    const exportToExcel = async () => {
        const headers = [
            'Sl', 'Year', 'Season', 'District', 'Block', 'MIP', 'Date', 'Venue', 'CB Type', 'CB Sub Type', 'Topic',
            'PG Name', 'Farmers(no.)', 'Male', 'Female', 'SC', 'ST', 'OBC', 'GEN', 'Resource Person Name', 'Designation'
        ];

        try {
            // Define the payload for the API request
            const payload = {
                seasonId: 0,
                blockId: 0,
                districtId: 0,
                mipId: 0,
                yearValue: year,
                capacityBuildingTypeName: CapacityBuildingTypeName || "",
                topic: Topic || "",
                venue: Venue || "",
                resourcePersonName: ResourcePerson || "",
                designation: designation || "",
                mipName: Mip || "",
                pgName: "",
                districtName: District || "",
                blockName: block || "",
                seasonName: Season || "",
                date: dates || "",
                farmers: "",
                pageNumber: page || 1,
                pageSize: 10000000,
            };

            console.log("Request Payload:", payload);

            // Make the API call
            const response = await apiService.post(
                "/capacity-building/get-capacity-building",
                payload
            );

            if (response && response.data && response.data.body) {
                const { data } = response.data.body;

                // Format the response data for the Excel sheet
                const tableData = data.map((item, index) => ({
                    Sl: index + 1,
                    Year: item.yearName || '',
                    Season: item.seasonName || '',
                    District: item.districtName || '',
                    Block: item.blockName || '',
                    MIP: item.mipName || '',
                    Date: item.date ? format(parseISO(item.date), "dd-MM-yyyy") : "N/A" || '',
                    Venue: item.venue || '',
                    Type: item.capacityBuildingTypeName || '',
                    SubType: item.subtypeName || '',
                    Topic: item.topic || '',
                    'PG Name': item.pgNames || '',
                    'Farmers(no.)': item.farmers || '',
                    'Male(no.)': item.male || '',
                    'Female(no.)': item.female || '',
                    'SC(no.)': item.sc || '',
                    'ST(no.)': item.st || '',
                    'OBC(no.)': item.obc || '',
                    'GEN(no.)': item.gen || '',
                    'Resource Person Name': item.resourcePerson || '',
                    Designation: item.designation || '',
                }));

                const ws = XLSX.utils.json_to_sheet(tableData);

                XLSX.utils.sheet_add_aoa(ws, [headers], { origin: 'A1' });

                ws['!cols'] = headers.map(() => ({ wch: 20 })); // Default width of 20 characters

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'CapacityBuildingData');


                const fileName = `CapacityBuildingData_${year}.xlsx`;

                XLSX.writeFile(wb, fileName);


                console.log("Excel file successfully exported!");
            } else {
                console.error("No data received or invalid response structure.");
            }
        } catch (error) {
            console.error("Error exporting data to Excel:", error);
        }
    };

    return (
        <Box style={{
            backgroundColor: "#f8f9fa",
            // minHeight: "100vh", 
            // padding: "0",
            overflowY: "auto" // Add this
        }}>

            {/* Simple Header */}
            <div style={{
                backgroundColor: "#ffffff",
                borderBottom: "3px solid #007bff",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
            }}>
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center py-3 px-4">
                        {/* Title */}
                        <div className="d-flex align-items-center">
                            <div>
                                <h1 style={{
                                    fontSize: "1.8rem",
                                    fontWeight: "600",
                                    color: "#2c3e50",
                                    margin: "0"
                                }}>
                                    Capacity Building Management
                                </h1>
                            </div>
                        </div>

                        {/* Controls */}
                        <div className="d-flex align-items-center gap-3">
                            {/* Year Selector */}
                            <div className="d-flex align-items-center">
                                <label style={{
                                    fontWeight: "500",
                                    color: "#495057",
                                    marginRight: "10px",
                                    fontSize: "14px"
                                }}>
                                    Year:
                                </label>
                                <select
                                    className="form-select"
                                    value={year || 0}
                                    onChange={(e) => setYear(Number(e.target.value))}
                                    style={{
                                        border: "1px solid #ced4da",
                                        borderRadius: "6px",
                                        padding: "6px 12px",
                                        fontSize: "14px",
                                        minWidth: "100px",
                                        backgroundColor: "#fff"
                                    }}
                                >
                                    <option value={0} disabled>Select Year</option>
                                    {years.map((yr) => (
                                        <option key={yr.yearId} value={yr.yearValue}>
                                            {yr.yearValue}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Buttons */}
                            <Button
                                variant="contained"
                                onClick={() => navigate("/addcapacitybuild")}
                                style={{
                                    backgroundColor: "#28a745",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "8px 16px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    textTransform: "none"
                                }}
                            >
                                + Add New
                            </Button>

                            <Button
                                variant="contained"
                                startIcon={<Download />}
                                onClick={exportToExcel}
                                style={{
                                    backgroundColor: "#007bff",
                                    border: "none",
                                    borderRadius: "6px",
                                    padding: "8px 16px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    textTransform: "none"
                                }}
                            >
                                Export Excel
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="container-fluid" style={{ padding: "20px" }}>
                {/* Table Container */}
                <div style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100vh - 160px)"
                }}>
                    <div style={{
                        flex: "1",
                        overflowY: "auto",
                        overflowX: "auto"
                    }}>
                        <div className="table-responsive">

                            <table className="table table-hover mb-0" style={{
                                minWidth: "2500px",
                                backgroundColor: "#fff"
                            }}>
                                <thead style={{
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    position: "sticky",
                                    top: "0",
                                    zIndex: "10"
                                }}>
                                    <tr>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            textAlign: "center",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "60px"
                                        }}>
                                            SL
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            textAlign: "center",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "80px"
                                        }}>
                                            Year
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "120px"
                                        }}>
                                            Season
                                            <br />
                                            <select
                                                className="form-control form-control-sm mt-2"
                                                value={Season}
                                                onChange={(e) => { setSeason(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            >
                                                <option value="">All</option>
                                                <option value="Rabi">Rabi</option>
                                                <option value="Kharif">Kharif</option>
                                            </select>
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "140px"
                                        }}>
                                            District
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={District}
                                                onChange={(e) => {
                                                    if (dist === 0) {
                                                        setDistrict(e.target.value);
                                                        setPage(1);
                                                    }
                                                }}
                                                disabled={dist > 0}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "120px"
                                        }}>
                                            Block
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={block}
                                                onChange={(e) => {
                                                    if (blk === 0) {
                                                        setBlock(e.target.value);
                                                        setPage(1);
                                                    }
                                                }}
                                                disabled={blk > 0}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "150px"
                                        }}>
                                            MIP
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={Mip}
                                                onChange={(e) => { setMip(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "120px"
                                        }}>
                                            Date
                                            <br />
                                            <input
                                                type="date"
                                                className="form-control form-control-sm mt-2"
                                                value={dates}
                                                onChange={(e) => { setDate(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "120px"
                                        }}>
                                            Venue
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={Venue}
                                                onChange={(e) => { setVenue(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "130px"
                                        }}>
                                            CB Type
                                            <br />
                                            <select
                                                className="form-control form-control-sm mt-2"
                                                value={CapacityBuildingTypeName}
                                                onChange={(e) => { setCapacityBuildingTypeName(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            >
                                                <option value="">All</option>
                                                <option value="Awareness Meeting">Awareness Meeting</option>
                                                <option value="Cluster Training">Cluster Training</option>
                                                <option value="Exposure Visit">Exposure Visit</option>
                                            </select>
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "140px"
                                        }}>
                                            CB Sub Type
                                            <br />
                                            <select
                                                className="form-control form-control-sm mt-2"
                                                value={CapacityBuildingSubTypeName}
                                                onChange={(e) => {
                                                    setCapacityBuildingSubTypeName(e.target.value);
                                                    setPage(1);
                                                }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            >
                                                <option value="">All</option>
                                                {SubtypeList.map((item) => (
                                                    <option
                                                        key={item.capacityBuildingSubtypeId}
                                                        value={item.subtypeName}
                                                    >
                                                        {item.subtypeName}
                                                    </option>
                                                ))}
                                            </select>
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "150px"
                                        }}>
                                            Topic
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={Topic}
                                                onChange={(e) => { setTopic(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "180px"
                                        }}>
                                            PG (name)
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "100px",
                                            textAlign: "center"
                                        }}>
                                            Farmers (no.)
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "70px",
                                            textAlign: "center"
                                        }}>
                                            Male
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "80px",
                                            textAlign: "center"
                                        }}>
                                            Female
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "60px",
                                            textAlign: "center"
                                        }}>
                                            SC
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "60px",
                                            textAlign: "center"
                                        }}>
                                            ST
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "70px",
                                            textAlign: "center"
                                        }}>
                                            OBC
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "70px",
                                            textAlign: "center"
                                        }}>
                                            GEN
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "150px"
                                        }}>
                                            Resource Person Name
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={ResourcePerson}
                                                onChange={(e) => { setResourcePerson(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            borderRight: "1px solid rgba(255,255,255,0.2)",
                                            minWidth: "120px"
                                        }}>
                                            Designation
                                            <br />
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="form-control form-control-sm mt-2"
                                                value={designation}
                                                onChange={(e) => { setDesignation(e.target.value); setPage(1); }}
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #ced4da",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    color: "#333",
                                                    padding: "4px 8px"
                                                }}
                                            />
                                        </th>
                                        <th style={{
                                            padding: "15px 12px",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            textAlign: "center",
                                            minWidth: "120px"
                                        }}>
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "13px" }}>
                                    {alldata.map((data, index) => (
                                        <tr key={index} style={{
                                            backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                                            borderBottom: "1px solid #dee2e6"
                                        }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                                            }}>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {(page - 1) * 10 + index + 1}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "500",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.yearName}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                <span style={{
                                                    backgroundColor: data.seasonName === 'Rabi' ? '#d4edda' : '#fff3cd',
                                                    color: data.seasonName === 'Rabi' ? '#155724' : '#856404',
                                                    padding: "3px 8px",
                                                    borderRadius: "4px",
                                                    fontSize: "11px",
                                                    fontWeight: "500"
                                                }}>
                                                    {data.seasonName}
                                                </span>
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontWeight: "500"
                                            }}>
                                                {data.districtName}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.blockName}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontSize: "12px"
                                            }}>
                                                {data.mipName}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontWeight: "500"
                                            }}>
                                                {data.date ? format(parseISO(data.date), "dd-MM-yyyy") : "N/A"}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.venue}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                <span style={{
                                                    backgroundColor: '#e7f3ff',
                                                    color: '#0066cc',
                                                    padding: "3px 8px",
                                                    borderRadius: "4px",
                                                    fontSize: "11px",
                                                    fontWeight: "500"
                                                }}>
                                                    {data.capacityBuildingTypeName}
                                                </span>
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontSize: "12px"
                                            }}>
                                                {data.subtypeName}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontSize: "12px"
                                            }}>
                                                {data.topic}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontSize: "12px"
                                            }}>
                                                {data.pgNames}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                <span style={{
                                                    backgroundColor: '#007bff',
                                                    color: 'white',
                                                    padding: "3px 8px",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    fontWeight: "600"
                                                }}>
                                                    {data.farmers}
                                                </span>
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#007bff",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.male}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#dc3545",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.female}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#6f42c1",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.sc}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#fd7e14",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.st}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#28a745",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.obc}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center",
                                                fontWeight: "600",
                                                color: "#ffc107",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.gen}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6",
                                                fontWeight: "500"
                                            }}>
                                                {data.resourcePerson}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                color: "#495057",
                                                borderRight: "1px solid #dee2e6"
                                            }}>
                                                {data.designation}
                                            </td>
                                            <td style={{
                                                padding: "12px 8px",
                                                textAlign: "center"
                                            }}>
                                                <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                                                    <button
                                                        className="btn btn-sm btn-info"
                                                        onClick={() => handleView(data)}
                                                        title="View"
                                                        style={{
                                                            padding: "4px 8px",
                                                            fontSize: "12px"
                                                        }}
                                                    >
                                                        <FaEye />
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-success"
                                                        onClick={() => handleOpenEdit(data)}
                                                        title="Edit"
                                                        style={{
                                                            padding: "4px 8px",
                                                            fontSize: "12px"
                                                        }}
                                                    >
                                                        <FaRegEdit />
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => { handleDelete(data); }}
                                                        title="Delete"
                                                        style={{
                                                            padding: "4px 8px",
                                                            fontSize: "12px"
                                                        }}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>


                </div>
                {/* Simple Pagination */}
                <div className='d-flex justify-content-between align-items-center py-3 px-3' style={{
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #dee2e6"
                }}>
                    <div>
                        <span style={{
                            color: "#6c757d",
                            fontSize: "14px"
                        }}>
                            Showing <strong>{(page - 1) * 10 + 1}</strong> to <strong>{Math.min(page * 10, totalItems)}</strong> of <strong>{totalItems}</strong> entries
                        </span>
                    </div>
                    <div>
                        <Pagination className="mb-0">
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
                            {renderPaginationItems()}
                            <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
                            <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
                        </Pagination>
                    </div>
                </div>
            </div>

            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Edit Capacity Building</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal" error={!!errors.yearId}>
                        <InputLabel id="year-label">Year  <span style={{ color: "red" }}>*</span></InputLabel>
                        <Select
                            labelId="year-label"
                            name="yearId"
                            value={formData.yearId || ""}
                            onChange={handleChange}
                        >
                            {years.map((year) => (
                                <MenuItem key={year.yearId} value={year.yearId}>
                                    {year.yearValue}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.yearId && <FormHelperText>{errors.yearId}</FormHelperText>}
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.seasonId}>
                        <InputLabel id="season-label">Season  <span style={{ color: "red" }}>*</span></InputLabel>
                        <Select
                            labelId="season-label"
                            name="seasonId"
                            value={formData.seasonId || ""}
                            onChange={handleChange}
                        >
                            {seasons.map((season) => (
                                <MenuItem key={season.seasonId} value={season.seasonId}>
                                    {season.seasonName}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.seasonId && <FormHelperText>{errors.seasonId}</FormHelperText>}
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.capacityBuildingTypeId}>
                        <InputLabel id="capacity-building-type-label">Capacity Building Type  <span style={{ color: "red" }}>*</span></InputLabel>
                        <Select
                            labelId="capacity-building-type-label"
                            name="capacityBuildingTypeId"
                            value={formData.capacityBuildingTypeId || ""}
                            onChange={handleChange}
                        >
                            {capacityBuildingTypes.map((type) => (
                                <MenuItem key={type.capacityBuildingTypeId} value={type.capacityBuildingTypeId}>
                                    {type.typeName}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.capacityBuildingTypeId && <FormHelperText>{errors.capacityBuildingTypeId}</FormHelperText>}
                    </FormControl>


                    <FormControl fullWidth margin="normal" error={!!errors.capacityBuildingSubtypeId}>
                        <InputLabel id="subtype-label">
                            Subtype <span style={{ color: "red" }}>*</span>
                        </InputLabel>

                        <Select
                            name="capacityBuildingSubtypeId"
                            value={formData.capacityBuildingSubtypeId || ""}
                            onChange={handleChange}
                        >
                            {subtypes.length > 0 &&
                                subtypes.map((st) => (
                                    <MenuItem key={st.capacityBuildingSubtypeId} value={st.capacityBuildingSubtypeId}>
                                        {st.subtypeName}
                                    </MenuItem>
                                ))}
                        </Select>


                        {errors.capacityBuildingSubtypeId && (
                            <FormHelperText>{errors.capacityBuildingSubtypeId}</FormHelperText>
                        )}
                    </FormControl>


                    <FormControl fullWidth margin="normal" error={!!errors.districtId}>
                        <Autocomplete
                            options={districtOptions}
                            getOptionLabel={(option) => option.districtName}
                            value={districtOptions.find((district) => district.districtId === formData.districtId) || null}
                            onChange={(event, newValue) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    districtId: newValue ? newValue.districtId : "",
                                }));
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            District<span style={{ color: "red" }}>*</span>
                                        </>
                                    }
                                    variant="outlined"
                                    error={!!errors.districtId}
                                    helperText={errors.districtId}
                                />
                            )}
                        />
                    </FormControl>

                    {/* Block Dropdown */}
                    <FormControl fullWidth margin="normal" error={!!errors.blockId}>
                        <Autocomplete
                            options={blockOptions}
                            getOptionLabel={(option) => option.blockName}
                            value={blockOptions.find((block) => block.blockId === formData.blockId) || null}
                            onChange={(event, newValue) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    blockId: newValue ? newValue.blockId : "",
                                }));
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            Block<span style={{ color: "red" }}>*</span>
                                        </>
                                    }
                                    variant="outlined"
                                    error={!!errors.blockId}
                                    helperText={errors.blockId}
                                />
                            )}
                        />
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.mipIds}>
                        <Autocomplete
                            multiple
                            options={mipOptions}
                            getOptionLabel={(option) => option.mipname}
                            value={mipOptions.filter((mip) => formData.mipIds.includes(mip.mipid))}
                            onChange={(event, newValue) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    mipIds: newValue.map((mip) => mip.mipid),
                                }));
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            MIPs<span style={{ color: "red" }}>*</span>
                                        </>
                                    }
                                    variant="outlined"
                                    error={!!errors.mipIds}
                                    helperText={errors.mipIds || "Required"}
                                />
                            )}
                        />
                    </FormControl>
                    <TextField
                        name="date"

                        label={
                            <>
                                Date<span style={{ color: "red" }}>*</span>
                            </>
                        }
                        type="date"
                        fullWidth
                        value={formData.date || ""}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        margin="normal"
                        error={!!errors.date}
                        helperText={errors.date}
                    />
                    <TextField
                        name="venue"
                        label={
                            <>
                                Venue<span style={{ color: "red" }}>*</span>
                            </>
                        }
                        fullWidth
                        value={formData.venue || ""}
                        onChange={handleChange}
                        margin="normal"
                        error={!!errors.venue}
                        helperText={errors.venue}
                    />
                    <TextField
                        name="topic"
                        label={
                            <>
                                Topic<span style={{ color: "red" }}>*</span>
                            </>
                        }
                        fullWidth
                        value={formData.topic || ""}
                        onChange={handleChange}
                        margin="normal"
                        error={!!errors.topic}
                        helperText={errors.topic}
                    />


                    <FormControl fullWidth margin="dense" error={!!errors.producerGroupIds}>
                        <Autocomplete
                            multiple
                            options={producerGroupOptions || []}
                            getOptionLabel={(option) => option.pgname || ""}
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option) =>
                                    option.pgname.toLowerCase().includes(inputValue.toLowerCase())
                                )
                            }
                            value={
                                producerGroupOptions?.filter((pg) =>
                                    formData.producerGroupIds?.includes(pg.producerGroupId)
                                ) || []
                            }
                            onChange={(event, newValue) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    producerGroupIds: newValue.map((pg) => pg.producerGroupId),
                                }));
                            }}
                            renderOption={(props, option, { selected }) => (
                                <li {...props} key={option.producerGroupId}>
                                    <Checkbox checked={selected} />
                                    {option.pgname}
                                </li>
                            )}
                            renderTags={(selected, getTagProps) =>
                                selected.map((option, index) => (
                                    <Chip key={option.producerGroupId} label={option.pgname} {...getTagProps({ index })} />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={
                                        <>
                                            Producer Groups<span style={{ color: "red" }}>*</span>
                                        </>
                                    }
                                    variant="outlined"
                                    fullWidth
                                    required
                                    error={!!errors.producerGroupIds}
                                    helperText={errors.producerGroupIds}
                                />
                            )}
                            isOptionEqualToValue={(option, value) =>
                                option.producerGroupId === value.producerGroupId
                            }
                        />
                    </FormControl>


                    <Autocomplete
                        multiple
                        options={farmers}
                        getOptionLabel={(option) => option.FarmerName}
                        value={farmers.filter((farmer) => formData.farmerIds.includes(farmer.FarmerId))}
                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    name: "farmerIds",
                                    value: newValue.map((farmer) => farmer.FarmerId),
                                },
                            });
                        }}
                        isOptionEqualToValue={(option, value) => option.FarmerId === value.FarmerId}
                        renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.FarmerId}>
                                <Checkbox checked={selected} />
                                {option.FarmerName}
                            </li>
                        )}
                        renderTags={(selected, getTagProps) =>
                            selected.map((option, index) => (
                                <Chip key={option.FarmerId} label={option.FarmerName} {...getTagProps({ index })} />
                            ))
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={
                                    <>
                                        Farmer <span style={{ color: "red" }}>*</span>
                                    </>
                                }
                                variant="outlined"
                                fullWidth
                                error={!!errors.farmerIds}
                                helperText={errors.farmerIds}
                            />
                        )}
                    />


                    <TextField
                        name="resourcePerson"
                        label={
                            <>
                                Resource Person<span style={{ color: "red" }}>*</span>
                            </>
                        }
                        fullWidth
                        value={formData.resourcePerson || ""}
                        onChange={handleChange}
                        margin="normal"
                        error={!!errors.resourcePerson}
                        helperText={errors.resourcePerson}
                    />
                    <TextField
                        name="designation"
                        label={
                            <>
                                Designation<span style={{ color: "red" }}>*</span>
                            </>
                        }
                        fullWidth
                        value={formData.designation || ""}
                        onChange={handleChange}
                        margin="normal"
                        error={!!errors.designation}
                        helperText={errors.designation}
                    />


                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button color="primary" onClick={handleSaveEdit}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );

};

export default Capacitybuild;